import * as React from 'react';
import { HTML_CLASSES } from '../../../../../constants/product.constants';
import { useProductContext } from '../../../../../contexts/ProductContext';

export const ProductPrice: React.FC = () => {
    const { price, oldPrice } = useProductContext();
    return (
        <div className={HTML_CLASSES.PRODUCT_PRICING}>
            <div className={HTML_CLASSES.PRODUCT_PRICING_OPTION}>
                {oldPrice && (
                    <span className={HTML_CLASSES.PRICE}>
                        <del>{oldPrice}</del>
                    </span>
                )}
                <span className={HTML_CLASSES.PRICE}>{price.valueLabel}</span>
            </div>
        </div>
    );
};
